const SidebarFooter = () => {
    return(
        <div className="sidebar-footer">
            <div>Versão 1.4.7</div>
            <div>© Smart Olfativos</div>
        </div>
    )
}

export default SidebarFooter;